
  import * as strapiRuntime$afRUwrX6QzXA7iOssltFQfTSeGBIXkWe77oyBLgI6wA from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_@capacitor+preferences@7.0.2_@capacitor+core@8.1.0__db0@0.3.2_idb-ke_9f565ad83f256023c62271016450d572/node_modules/@nuxt/image/dist/runtime/providers/strapi'
import * as belongRuntime$SqKuZtrwoACNXnqD9XXrClJfRn88rzdf1fC3PPAZI3Q from '/app/apps/website/app/providers/s3-belong.ts'
import * as ipxRuntime$Cv1UL5STNFU5hFR0_45JQLh1xkdzhXp9X0yHq3dm_457Oqs from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_@capacitor+preferences@7.0.2_@capacitor+core@8.1.0__db0@0.3.2_idb-ke_9f565ad83f256023c62271016450d572/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['strapi']: { provider: strapiRuntime$afRUwrX6QzXA7iOssltFQfTSeGBIXkWe77oyBLgI6wA, defaults: undefined },
  ['belong']: { provider: belongRuntime$SqKuZtrwoACNXnqD9XXrClJfRn88rzdf1fC3PPAZI3Q, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$Cv1UL5STNFU5hFR0_45JQLh1xkdzhXp9X0yHq3dm_457Oqs, defaults: {} }
    }
  }
